import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { AuthenticateInstitutionRequest } from '@cash-web/shared-util-protos/squareup/franklin/bankbook.pb'
import { AuthenticateInstitutionResponse } from '@cash-web/shared-util-protos/squareup/franklin/bankbook.pb'

export const authenticateInstitution = (request: AuthenticateInstitutionRequest, options?: CashRequestOptions) =>
  post<AuthenticateInstitutionRequest, AuthenticateInstitutionResponse>('/2.0/cash/authenticate-institution', request, {
    ...options,
    rejectOnError: true,
  })
